import { render, staticRenderFns } from "./BalanceStatement-2.vue?vue&type=template&id=f17593d4"
import script from "./BalanceStatement-2.vue?vue&type=script&lang=js"
export * from "./BalanceStatement-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports